import { Form } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { PromptDataProfileEntity } from "src/app/features/PromptDataProfile/types/PromptDataProfileEntity";
import { SelectDynamic, TextInput } from "../../../../../components/Form/formComponents";
import { NumberInput } from "../../../../../components/Form/formComponents/Number/NumberInput";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import { promptDataTypeSelectConfig, statusSelectorConfig } from "../../../../../components/SearchForm/FormSearchUtils";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const PromptDataProfilesSearchForm: FC<SearchFormProps<PromptDataProfileEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();

    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={t("form.system.id")} name="id">
                <NumberInput name="id" readOnly={false} />
            </Form.Item>
            <Form.Item label={t("form.name")} name="name">
                <TextInput name="name" />
            </Form.Item>
            <Form.Item label={t("promptDataCreateForm.promptDataType")} name="promptDataType">
                <SelectDynamic
                    name="promptDataType"
                    label={t("promptDataCreateForm.promptDataType")}
                    fieldConfig={promptDataTypeSelectConfig}
                />
            </Form.Item>
            <Form.Item label={t("promptDataCreateForm.promptDataCode")} name="promptDataCode">
                <TextInput name="promptDataCode" />
            </Form.Item>
            <Form.Item label={t("form.status")} name="status">
                <SelectDynamic name="status" label={t("form.status")} fieldConfig={statusSelectorConfig} />
            </Form.Item>
        </SearchForm>
    );
};
